import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StudyTableUiService {
  hideParent: boolean = false;
  hideEmitter = new EventEmitter<boolean>();
  activeType: number = null;
  activeTypeEmitter = new EventEmitter<number>();
  constructor() {}
  changeHideStatus(): void {
    this.hideParent = !this.hideParent;
    this.hideEmitter.emit(this.hideParent);
  }
  changeActiveType(activeType: number) {
    this.activeType = activeType;
    this.activeTypeEmitter.emit(activeType);
  }
}
